function getHeight(selector: string) {
  return document.querySelector(selector)?.getBoundingClientRect().height ?? 0;
}

function getChildrenHeightSum(selector: string) {
  return Array.from(document.querySelector(selector)?.children ?? []).reduce(
    (sum, child) => sum + child.getBoundingClientRect().height,
    0,
  );
}

function getMetricInput(name: string, value: number | string) {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;

  if (typeof value === "number") {
    input.value = `${value === 0 ? "-" : Math.round(value)}`;
  } else {
    input.value = value === "" ? "-" : value;
  }

  return input;
}

const trackingMetricsElement = document.getElementById("tracking-metrics");

if (trackingMetricsElement) {
  document.addEventListener("DOMContentLoaded", () => {
    const topHeight = getHeight(".pda-top");
    let leftPaneHeight = topHeight + getChildrenHeightSum(".pda-left");
    const centerPaneHeight = topHeight + getChildrenHeightSum(".pda-right");
    let rightPaneHeight = getChildrenHeightSum(".pda-side");

    const mobileRightPaneHeight = getHeight(".pda-mobile-cta-box");
    const isMobile = mobileRightPaneHeight > 0;

    if (isMobile) {
      leftPaneHeight -= mobileRightPaneHeight;
      rightPaneHeight = mobileRightPaneHeight;
    }

    trackingMetricsElement.appendChild(
      getMetricInput("viewportCategory", isMobile ? "mobile" : "desktop"),
    );
    trackingMetricsElement.appendChild(
      getMetricInput("leftPaneHeight", leftPaneHeight),
    );
    trackingMetricsElement.appendChild(
      getMetricInput("centerPaneHeight", centerPaneHeight),
    );
    trackingMetricsElement.appendChild(
      getMetricInput("rightPaneHeight", rightPaneHeight),
    );
  });
}
